import { Role } from '~~/entities/user'

export default defineNuxtPlugin(() => {
  onNuxtReady(async () => {
    const route = useRoute()
    const { state, userRole, hasRole, userHasCompanies } = useUser()
    const shouldRedirectToEditor = userRole.value && (hasRole(Role.SuperAdmin) || userHasCompanies.value)

    if (route.path === '/login' && state.value.user) {
      if (shouldRedirectToEditor) return navigateTo('/admin')
      return navigateTo('/user/profile')
    }
  })
})
